/* =============================================================================
   THEME.JS — Clean Burn Theme
   ============================================================================= */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Search drawer
  // ---------------------------------------------------------------------------
  function initSearchDrawer() {
    const toggleBtns = document.querySelectorAll('[data-search-toggle]');
    const closeBtn   = document.querySelector('[data-search-close]');
    const drawer     = document.querySelector('[data-search-drawer]');
    const input      = drawer && drawer.querySelector('input[type="search"]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (input) setTimeout(() => input.focus(), 50);
      closeHelpDrawer();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // ---------------------------------------------------------------------------
  // Help drawer
  // ---------------------------------------------------------------------------
  function initHelpDrawer() {
    const toggleBtn = document.querySelector('[data-help-toggle]');
    const drawer    = document.querySelector('[data-help-drawer]');

    if (!drawer || !toggleBtn) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      closeSearchDrawer();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    toggleBtn.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function closeSearchDrawer() {
    const drawer = document.querySelector('[data-search-drawer]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  function closeHelpDrawer() {
    const drawer = document.querySelector('[data-help-drawer]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  // ---------------------------------------------------------------------------
  // Mobile nav
  // ---------------------------------------------------------------------------
  function initMobileNav() {
    const hamburger = document.querySelector('[data-hamburger]');
    const mobileNav = document.querySelector('[data-mobile-nav]');

    if (!hamburger || !mobileNav) return;

    hamburger.addEventListener('click', function () {
      const isOpen = mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open', !isOpen);
      mobileNav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      hamburger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  // ---------------------------------------------------------------------------
  // Announcement bar — duplicate messages for seamless scroll loop
  // ---------------------------------------------------------------------------
  function initAnnouncementBar() {
    const track = document.querySelector('.announcement-bar__track');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    // Clone all items for seamless infinite scroll
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  // ---------------------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    initSearchDrawer();
    initHelpDrawer();
    initMobileNav();
    initAnnouncementBar();
  });

})();
